import createDebug from "debug";

/**
 * Default namespace is 'people'.
 */
export const debugLog = createDebug("people");
